<template>
    <main class="container">
        <h1>
            {{ $t('intervention.title') }}
            <ReglePastille cle="demandeIntervention.definition" />
            <ReglePastille cle="demandeIntervention.droitDemande" />
            <ReglePastille cle="demandeIntervention.sauvegardeEtapes" />
            <ReglePastille cle="demandeIntervention.unSeulSite" />
        </h1>
        <InterventionStepsBar :step="step" />
        <div class="content-container">
            <StepOne
                v-if="this.step === 1"
                :title="$t('siteSelection.searchBar.title.request.intervention')"
                regle-cle="demandeIntervention.listeSites"
                @next="next"
            />
            <StepTwo v-if="this.step === 2" />
            <StepThree v-if="this.step === 3" :display-radio="true" :open-info-equipement="false" />
            <StepFour v-if="this.step === 4" />
            <StepFive v-if="this.step === 5" />
            <StepSix v-if="this.step === 6" />
        </div>
    </main>
    <BottomNavigation
        :back="back"
        :cancel="cancel"
        :confirm="request"
        :confirmButtonDisabled="!isValid"
        :first="step === 1"
        :last="step === 6"
        :next="next"
        :regleCle="step === 5 ? 'demandeIntervention.suivantEtape5' : undefined"
    />

    <AstreinteModal v-if="isHeureAstreinte && astreinteModalOpen" @cancel="astreinteModalOpen = false" />
    <JourFerieModal v-if="isJourFerie && jourFerieModalOpen" @cancel="jourFerieModalOpen = false" />
</template>

<script lang="ts">
import InterventionStepsBar from '../components/InterventionStepsBar.vue';
import StepOne from '../components/StepOne.vue';
import { defineComponent } from 'vue';
import BottomNavigation from '@/components/layout/BottomNavigation.vue';
import StepTwo from '../components/StepTwo.vue';
import StepFour from '../components/StepFour.vue';
import { Site } from '@/models/Site';
import StepThree from '../components/StepThree.vue';
import { EQUIPEMENT, INTERVENTION } from '../store/mutation-types';
import StepFive from '../components/StepFive.vue';
import StepSix from '../components/StepSix.vue';
import { InterventionModuleAction } from '../store/actions-types';
import { SITE_LIST } from '@/modules/SiteList/store/mutation-types';
import AstreinteModal from '@/modules/Intervention/components/AstreinteModal.vue';
import JourFerieModal from '@/modules/Intervention/components/JourFerieModal.vue';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    name: 'InterventionPage',
    components: {
        JourFerieModal,
        AstreinteModal,
        InterventionStepsBar,
        BottomNavigation,
        StepOne,
        StepTwo,
        StepThree,
        StepFour,
        StepFive,
        StepSix,
        ReglePastille,
    },
    beforeMount() {
        this.$store.dispatch(InterventionModuleAction.SHOW_ASTREINTE_MODALE);
    },
    data() {
        return {
            astreinteModalOpen: true,
            jourFerieModalOpen: true,
        };
    },
    methods: {
        cancel() {
            this.$router.back();
            this.reset();
        },
        next() {
            this.$store.commit(INTERVENTION.SET_STEP, this.step + 1);
        },
        back() {
            this.$store.commit(INTERVENTION.SET_STEP, this.step - 1);
        },
        request() {
            this.$store.dispatch(InterventionModuleAction.SEND_ASK_INTERVENTION);
        },
        reset() {
            this.$store.commit(`siteList/${SITE_LIST.RESET}`);
            this.$store.commit(`siteList/${SITE_LIST.SET_FILTER}`, '');
            this.$store.commit(`equipementModule/${EQUIPEMENT.SET_EQUIPEMENT_FILTER}`, '');
            this.$store.commit(INTERVENTION.RESET_INTERVENTION);
            this.$store.state.demandeInterventionModuleState.documents = [];
        },
    },
    computed: {
        selectedSite(): Site {
            return this.$store.getters.getInterventionSiteValue;
        },
        selectedEquipement(): Site {
            return this.$store.getters.getInterventionEquipementValue;
        },
        step: {
            get(): number {
                return this.$store.getters.getInterventionStep;
            },
            set(step: number) {
                if (step < this.step) {
                    this.$store.commit(INTERVENTION.RESET_TO_STEP, step);
                } else {
                    this.$store.commit(INTERVENTION.SET_STEP, step);
                }
            },
        },
        isValid() {
            return this.$store.getters.isInterventionFormValid;
        },
        isHeureAstreinte(): boolean {
            return this.$store.getters.isHeureAstreinte;
        },
        isJourFerie(): boolean {
            return this.$store.getters.isJourFerie;
        },
    },
    beforeRouteLeave(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
        this.reset();
        next();
    },
});
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 16px 24px;
}
.content-container {
    margin-top: 8px;
}
h1 {
    color: var(--color-principal);
    font-size: var(--font-size-large);
    font-family: 'Raleway', sans-serif !important;
    font-variant-numeric: lining-nums;
    font-weight: lighter;
    margin: 0 0 8px 0;
}
</style>
